"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const onchainPoolToken_1 = __importDefault(require("./onchainPoolToken"));
const lending_vault_watcher_1 = require("../config/contracts/lending-vault-watcher");
class OnchainLendingVault extends onchainPoolToken_1.default {
    constructor(onchain, vaultAddress) {
        super();
        this.lendingVaultCache = {};
        this.getOnchain = () => this.onchain;
        this.getVaultAddress = () => this.vaultAddress;
        this.getContractHelper = () => this.onchain.getContractHelper();
        this.getOffchainLendingVault = this.getOffchainPoolToken;
        this.onchain = onchain;
        this.vaultAddress = vaultAddress;
    }
    cleanCache() {
        this.cache = {};
        this.lendingVaultCache = {};
    }
    getPoolTokenAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.vaultAddress;
        });
    }
    getOffchainPoolToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.onchain.getOffchain().getLendingVault(this.vaultAddress);
        });
    }
    initializePoolToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getContractHelper().newLendingVault(yield this.getPoolTokenAddress());
        });
    }
    initializeToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const poolToken = yield this.getPoolToken();
            return this.getContractHelper().newERC20(yield poolToken.methods.underlying().call());
        });
    }
    // Available Liquidity
    initializeAvailableLiquidity() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingVaultWatcher = this.onchain.getContractHelper().newLendingVaultWatcher(lending_vault_watcher_1.LENDING_VAULT_WATCHER[this.onchain.network]);
            const amount = yield lendingVaultWatcher.methods.getAvailableLiquidity(this.vaultAddress).call();
            return this.normalize(amount);
        });
    }
    getAvailableLiquidity() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.lendingVaultCache.availableLiquidity)
                this.lendingVaultCache.availableLiquidity = this.initializeAvailableLiquidity();
            return this.lendingVaultCache.availableLiquidity;
        });
    }
}
exports.default = OnchainLendingVault;
